<template>
  <div>
    <Modal ref="modal">
      <template slot="cabecera">
        <h5 class="modal-title">
          <slot name="modalTitulo"></slot>
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </template>
      <template slot="cuerpo">
        <slot name="modalCuerpo" v-bind:item="item"></slot>
      </template>
      <template v-slot:pie>
        <button @click="eliminar()" type="button" class="btn btn-danger">
          <font-awesome-icon :icon="Icons.ELIMINAR" />
          Eliminar
        </button>
      </template>
    </Modal>
    <!--Tabs-->
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link active"
          id="aprobados-tab"
          data-bs-toggle="tab"
          href="#aprobados"
          role="tab"
          aria-controls="aprobados"
          aria-selected="false"
          >Aprobados</a
        >
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          id="pendientes-tab"
          data-bs-toggle="tab"
          href="#pendientes"
          role="tab"
          aria-controls="pendientes"
          aria-selected="true"
          >Pendientes</a
        >
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <!-- Aprobados -->
      <div
        class="tab-pane fade show active tab-aprobados"
        id="aprobados"
        role="tabpanel"
        aria-labelledby="aprobados-tab"
      >
        <tabla
          ref="tablaAprobados"
          :columnas="columnas"
          :busqueda="busqueda"
          :cargaManual="cargaManual"
          :facade="facade"
          v-on:evento-item-elegido="abrir($event)"
        ></tabla>
      </div>
      <!-- Pendientes -->
      <div
        class="tab-pane fade tab-pendientes"
        id="pendientes"
        role="tabpanel"
        aria-labelledby="pendientes-tab"
      >
        <Pendientes
          ref="pendientes"
          :busqueda="busqueda"
          :cargaManual="cargaManual"
          :columnas="columnas"
          :facade="pendingFacade"
          v-on:aprobado="aprobado($event)"
        >
          <template slot="modalTitulo">
            <slot name="modalTitulo"></slot>
          </template>
          <template v-slot:modalCuerpo="slotProps">
            <slot name="modalCuerpo" v-bind:item="slotProps.item"></slot>
          </template>
        </Pendientes>
      </div>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { Icons as IconConstants } from "../../constants";
import Modal from "./modals/Modal.vue";
import Pendientes from "./util/Pendientes.vue";
import Tabla from "./tablas/Tabla.vue";
import { Util } from "../../util";

export default {
  components: {
    FontAwesomeIcon,

    Modal,
    Pendientes,
    Tabla,
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean,
    columnas: Array,
    facade: Function,
    pendingFacade: Function,
  },
  data() {
    return {
      item: undefined,
    };
  },
  computed: {
    /** Constantes de iconos */
    Icons() {
      return IconConstants;
    },
  },
  methods: {
    /** Evento proxy para pasar a las tablas */
    recargar() {
      this.$refs.pendientes.recargar();
      this.$refs.tablaAprobados.recargar();
    },
    abrir(item) {
      this.item = Util.copiaProfunda(item);
      this.$refs.modal.abrir();
    },
    /** Cuando un item pendiente fue aprobado */
    aprobado(item) {
      // Agregar item aprobado a tabla de aprobados
      this.$refs.tablaAprobados.guardado(item);
    },
    eliminar() {
      Swal.fire({
        title: "¿Estás seguro?",
        icon: "question",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "rgb(125 133 140)",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "Cancelar",
        keydownListenerCapture: true,
        preConfirm: () => {
          return this.facade
            .delete(this.item)
            .then(() => {
              this.$refs.tablaAprobados.eliminado(this.item);
            })
            .catch(() => {
              Swal.showValidationMessage("Ocurrió un error al eliminar");
            });
        },
      }).then((result) => {
        // Si confirma
        if (result.isConfirmed) {
          Swal.fire({ title: "Eliminado!", icon: "success" });

          this.cerrar();
        }
      });
    },
    cerrar() {
      this.$refs.modal.cerrar();
    },
  },
};
</script>
